module.exports = __webpack_public_path__ + "static/media/logo harinera guadalupe.eb9062f7.jpg";